/**
 * Registry of partners allowed to enter the account-linking funnel at
 * /ixi-finance/partner/link. The entry URL's `utm_source` selects a profile;
 * an unknown source never opens the funnel (terminal error screen instead).
 * See docs/swiggy-account-linking.md.
 */

export interface PartnerProfile {
	/** Canonical partner key — also the analytics attribute value. */
	id: string;
	/** Funnel presentation: mobile-OTP-only (no social, no OTPless, no One-Tap). */
	otpOnly: boolean;
	/** `LoginConfig.product` override on this surface — the CMS `loginSDK/<product>`
	 * identifier (partner banner) and the SDK's analytics "Page Source". */
	loginProduct: string;
	/** Partner identifier in the partner-rewards API path
	 * (`/partner-rewards/api/v1/partners/<apiPartner>/links`). */
	apiPartner: string;
}

const PARTNERS: Record<string, PartnerProfile> = {
	swiggy: {
		id: 'swiggy',
		otpOnly: true,
		loginProduct: 'swiggy',
		apiPartner: 'SWIGGY',
	},
};

export function resolvePartner(
	utmSource: string | undefined,
): PartnerProfile | null {
	if (!utmSource) return null;
	return PARTNERS[utmSource.toLowerCase()] ?? null;
}
